import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PastWays = _resolveComponent("PastWays")!
  const _component_PastLayout = _resolveComponent("PastLayout")!

  return (_openBlock(), _createBlock(_component_PastLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_PastWays)
    ]),
    _: 1
  }))
}